import React, { FC } from 'react';
import { useTheme } from '../../../../../../../theme';
import { FareFeaturePaymentType } from '@websky/graphql';
import cn from 'classnames';
import { WithTooltip } from '@shared/ui/';
import { FareGroupOption } from '../../../../model/types';

export interface Props extends FareGroupOption {
	className?: string;
}

const ListOption: FC<Props> = ({
	className,
	title,
	optionIcon,
	paymentIcon,
	paymentType,
	optionType,
	param,
	tooltip
}) => {
	const { ListOption: css } = useTheme('Entities').FareGroupV2;

	return (
		<div
			data-option-type={optionType}
			className={cn(css.root, className, {
				[css.pay]: paymentType === FareFeaturePaymentType.Pay,
				[css.free]: paymentType === FareFeaturePaymentType.Free,
				[css.notAvailable]: paymentType === FareFeaturePaymentType.NotAvailable,
				[css.withTooltip]: !!tooltip
			})}
		>
			<div className={css.left}>
				{!!optionIcon && <div className={css.optionIcon}>{optionIcon}</div>}
				{!!title && <div className={css.title}>{title}</div>}
			</div>

			<WithTooltip title={tooltip} enterTouchDelay={0}>
				<div className={css.right}>
					{!!param && <div className={css.param}>{param}</div>}
					{!!paymentIcon && <div className={css.paymentIcon}>{paymentIcon}</div>}
				</div>
			</WithTooltip>
		</div>
	);
};

export default ListOption;
